import { Link } from 'react-router-dom';
import { Routes } from '@/routes';
import { Flex } from '@/components';
import { formatDate } from '@/utils/func';
import { statusColor } from './helpdeskUtils';
import { useTranslation } from 'react-i18next';

export interface HelpdeskItemMobile extends RedmineIssueEntity {
}

export function HelpDeskItem(props: HelpdeskItemMobile) {

  const [t] = useTranslation(['common', 'helpdesk']);

  return (
    <Link
      to={`${Routes.HelpdeskIssues}/${props.id}`}
      style={{ textDecoration: 'none', border: '0.5px solid #d9d9d9' }}
      className="text-sm text-darker flex-col w-full rounded-xl my-0.5 py-2 px-3 bg-[#f4f4f4]"
    >
      <div className="flex w-full justify-between items-center">
        <p>{t('common:labels:id')}: {props.id}</p>
        <p style={{ color: statusColor[props.status.name] }}>{props.status.name}</p>
      </div>
      <Flex className="flex w-full justify-between items-center mb-4">
        <span className="text-dark">{t('common:labels.type')}: {props.category.name}</span>
        <span className="text-dark">
          {formatDate(props.created_on, 'jYYYY/jMM/jDD')}
        </span>
      </Flex>
      <p className="w-full text-base">{props.subject}</p>
    </Link>
  );
}

export default HelpDeskItem;
